import React, { useState } from 'react';
import logo from "../../../img/community_desexing.png";
import { useMsal } from "@azure/msal-react";
import { useHistory } from "react-router-dom";
import LandingCommunityLogsTable from "./LandingCommunityLogsTable";
import LandingCommunityLogsTableTeam from "./LandingCommunityLogsTableTeam";
import LandingCommunityLogsTableVet from "./LandingCommunityLogsTableVet";
// Import other components if available
// import TeamVouchersTable from "./TeamVouchersTable";
// import VetClinicsList from "./VetClinicsList";

export default function LandingCommunityLogs({ account }) {
    const history = useHistory();
    const { instance, accounts } = useMsal();
    const userAccount = accounts[0];
    const groupIds = accounts[0].idTokenClaims.groups ? accounts[0].idTokenClaims.groups.join(',') : '';
    // State to manage active tab
    const [activeTab, setActiveTab] = useState('myVouchers');
const hostname = String(window.location.hostname).toLowerCase();


    var targetPortal = "community";
    if (hostname.includes("community")   ) {
        targetPortal = "community";
    } 
    else if(hostname.includes("outreach") ){
        targetPortal = "outreach";
    }else {
        targetPortal = "inspectors";
    }
    const [portal, setPortal] = useState(targetPortal); // ✅ but only if you really need local state

    // Handler to switch tabs
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    // Render content based on active tab
    const renderTabContent = () => {
        switch (activeTab) {
            case 'myVouchers':
                return <LandingCommunityLogsTable staffEmail={userAccount.username} groupIds = {groupIds} targetPortal = {targetPortal} />;
            case 'teamVouchers':
                // Replace with your Team Vouchers component
                // return <TeamVouchersTable teamEmail={userAccount.username} />;
                return <LandingCommunityLogsTableTeam account={userAccount} targetPortal = {targetPortal}/>;
            case 'vetClinics':
                // Replace with your Vet Clinics component
                // return <VetClinicsList />;
                return <LandingCommunityLogsTableVet account={userAccount} staffEmail={userAccount.username} targetPortal = {targetPortal}/>;
            default:
                return null;
        }
    };

    return (
        <div>
            {/* Back to Landing Page Link */}
            <div style={{ padding: 10 }}>
                <a href="#" onClick={(e) => { e.preventDefault(); history.push('/'); }}>Back to the landing page</a>
            </div>

            {/* Header Section */}
            <div style={{ display: 'flex', background: 'lightblue', padding: '0 0 30px 0' }}>
                <div style={{ flexGrow: 1, marginTop: 20, paddingLeft: 20 }}>
                    <h1>Community Logs</h1>
                    <p>Access vouchers logged by {userAccount.username}</p>
                </div>
                <img src={logo} alt="Community Desexing" style={{ width: 200, marginTop: 20 }} />
            </div>

            {/* Tabs Navigation */}
            <div style={{ borderBottom: '1px solid #ccc', marginBottom: 20 }}>
                <button
                    onClick={() => handleTabChange('myVouchers')}
                    style={{
                        padding: '10px 20px',
                        border: 'none',
                        borderBottom: activeTab === 'myVouchers' ? '2px solid blue' : 'none',
                        background: 'none',
                        cursor: 'pointer',
                        fontWeight: activeTab === 'myVouchers' ? 'bold' : 'normal'
                    }}
                >
                    My Vouchers
                </button>
                <button
                    onClick={() => handleTabChange('teamVouchers')}
                    style={{
                        padding: '10px 20px',
                        border: 'none',
                        borderBottom: activeTab === 'teamVouchers' ? '2px solid blue' : 'none',
                        background: 'none',
                        cursor: 'pointer',
                        fontWeight: activeTab === 'teamVouchers' ? 'bold' : 'normal'
                    }}
                >
                    Team Vouchers
                </button>
                <button
                    onClick={() => handleTabChange('vetClinics')}
                    style={{
                        padding: '10px 20px',
                        border: 'none',
                        borderBottom: activeTab === 'vetClinics' ? '2px solid blue' : 'none',
                        background: 'none',
                        cursor: 'pointer',
                        fontWeight: activeTab === 'vetClinics' ? 'bold' : 'normal'
                    }}
                >
                    Vet Clinics
                </button>
            </div>

            {/* Tab Content */}
            <div>
                {renderTabContent()}
            </div>
        </div>
    );
}
